import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge conditional class lists, letting later Tailwind utilities win over earlier
 * ones in the same family (`p-2` then `p-4` resolves to `p-4`, not both).
 *
 * `clsx` flattens the conditional forms — arrays, objects, falsy values — into one
 * string; `twMerge` then resolves Tailwind conflicts within it. Needed wherever a
 * component takes a `className` override that must be able to beat its own defaults,
 * which plain string interpolation cannot do.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
